import { render } from "./CertificationBillAdjustment.vue?vue&type=template&id=dff55990&ts=true"
import script from "./CertificationBillAdjustment.vue?vue&type=script&lang=ts"
export * from "./CertificationBillAdjustment.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__